export default {
  setTransactions(context, payload) {
    context.commit('SET_TRANSACTIONS', payload)
  },

  setTransactionsMeta(context, payload) {
    context.commit('SET_TRANSACTIONS_META', payload)
  },

  setDebitTransactions(context, payload) {
    context.commit('SET_DEBIT_TRANSACTIONS', payload)
  },

  setCreditTransactions(context, payload) {
    context.commit('SET_CREDIT_TRANSACTIONS', payload)
  },

  setFutureTransactions(context, payload) {
    context.commit('SET_FUTURE_TRANSACTIONS', payload)
  },

  setWalletSummary(context, payload) {
    context.commit('SET_WALLET_SUMMARY', payload)
  },

  setAmountToReceive(context, payload) {
    context.commit('SET_AMOUNT_TO_RECEIVE', payload)
  },

  setWalletUpdatedAt(context, payload) {
    context.commit('SET_WALLET_UPDATED_AT', payload)
  },

  setLastDraw(context, payload) {
    context.commit('SET_LAST_DRAW', payload)
  },

  setExternalToken(context, payload) {
    context.commit('SET_EXTERNAL_TOKEN', payload)
  },

  setCashbackAmountToReceive(context, payload) {
    context.commit('SET_CASHBACK_AMOUNT_TO_RECEIVE', payload)
  },

  setTransactionsLoadeds(context, payload) {
    context.commit('SET_TRANSACTIONS_LOADEDS', payload)
  },

  setBonusReceived(context, payload) {
    context.commit('SET_BONUS_RECEIVED', payload)
  },

  setAccountsPix(context, payload) {
    context.commit('SET_ACCOUNTS_PIX', payload)
  },

  setListPixKey(context, payload) {
    if (Array.isArray(payload)) {
      // invalid key per last
      payload.sort((a, b) => {
        if (a.verified === 3 && b.verified !== 3) {
          return 1
        } else if (a.verified !== 3 && b.verified === 3) {
          return -1
        } else {
          return 0
        }
      })
    }

    context.commit('SET_LIST_PIX_KEY', payload)
  },

  setChosenOwner(context, payload) {
    context.commit('SET_USER_SELECTED', payload)
  },

  setSelectedAccountTransfer(context, payload) {
    context.commit('SET_SELECTED_ACCOUNT_TRANFER', payload)
  },

  setAttemptRegisterPhone(context, payload) {
    context.commit('SET_ATTEMPT_REGISTER_PHONE', payload)
  },

  setCreditedPixAmount(context, payload) {
    context.commit('SET_CREDITED_PIX_AMOUNT', payload)
  },

  setWalletDetails(context, payload) {
    context.commit('SET_WALLET_DETAILS', payload)
  },

  setPhoneWalletInfo(context, payload) {
    context.commit('SET_PHONE_WALLET_INFO', payload)
  },
}
